module.exports = __webpack_public_path__ + "img/empty-menu.a7f6610c.jpg";